// extracted by mini-css-extract-plugin
export default {"separator":"edit_separator__jtOmW","identifiedLocation":"edit_identifiedLocation__1DXoE"};